<template>
  <b-modal id="add_note_modal" ref="add_note_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <!-- Different modal header depending on type note being left -->
        <h1>
          <i class="fas fa-comment-dots"></i>
          <span v-if="$store.state.notes.type === 'company'">Add Company/Contact Note</span>
          <span v-else-if="$store.state.notes.type === 'contact'">Add Contact Note</span>
          <span v-else-if="$store.state.notes.type === 'order_job'">Add Order Job Note</span>
          <span v-else-if="$store.state.notes.type === 'worker'">Add Worker Note</span>
        </h1>
        <p id="mh-info">Add a new note on {{ $store.state.notes.name }}</p>
      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>
    <div>
      <ValidationObserver ref="addNoteForm" slim>
        <form role="form" @submit.prevent="create_note()">
          <div class="row">
            <div class="col-12 form-group" v-if="$store.state.notes.type === 'company'">
              <ValidationProvider rules="required" v-slot="{errors, classes}" name="Leave Note On" tag="div">
                <label class="form-label" for="note_on">Leave Note On</label>
                <multiselect v-model="company_note_on" placeholder="" id="note_on" label="note_on" track-by="name" :options="ms_opts.company_note_on" :option-height="200"
                             :custom-label="note_on_label" :show-labels="false" class="requiredField" :class="classes">
                  <template slot="singleLabel" slot-scope="props">
                    <span class="option__desc_single">
                      <span class="option__title">{{ props.option.name }}</span>
                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <span class="option__title">{{ props.option.name }}</span>
                      <span class="option__small">{{ props.option.job_title }}</span>
                    </div>
                  </template>
                </multiselect>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="col-12 form-group">
              <ValidationProvider rules="required" v-slot="{errors, classes}" name="Note Type" tag="div">
                <label class="form-label" for="note_type">Note Type</label>
                <multiselect v-model="note.type" placeholder="" id="note_type" label="note_type" track-by="id" :options="ms_opts.note_type" :option-height="200"
                             :custom-label="note_type_label" :show-labels="false" class="requiredField" :class="classes"
                             group-values="data" group-label="header">
                </multiselect>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div :class="[note.is_call ? 'col-6' : 'col-12']">
              <div class="row">
                <label :class="[note.is_call ? 'col-7 cardLabel' : 'col-8 cardLabel']" for="is_call">Call Note</label>
                <div :class="[note.is_call ? 'col-5 cardLabel' : 'col-4 cardLabel']">
                  <bootstrap-toggle v-model="note.is_call" name="is_call" id="is_call" :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>
            <div class="col-6" v-if="note.is_call">
              <div class="row">
                <label class="col-7 cardLabel" for="voicemail">Left Voicemail</label>
                <div class="col-5">
                  <bootstrap-toggle v-model="note.voicemail" name="voicemail" id="voicemail" :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>
            <div class="col-12 form-group" v-if="note.is_call">
              <ValidationProvider :rules="{'required' : note.is_call}" v-slot="{errors, classes}" name="Type of Call" tag="div">
                <label class="form-label" for="call_type">Type of Call</label>
                <multiselect v-model="note.call_type" placeholder="" id="call_type" :options="ms_opts.call_type"
                             class="requiredField" :class="classes" :disabled="note.voicemail">
                </multiselect>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="col-12" v-if="$store.state.notes.type !== 'worker'">
              <div class="row">
                <label class="col-md-8 cardLabel" for="decision_maker">Decision Maker</label>
                <div class="col-md-4">
                  <bootstrap-toggle v-model="note.decision_maker" name="decision_maker" id="decision_maker" :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>
            <div :class="[note.discussed_tax ? 'col-6' : 'col-12']" v-if="$store.state.notes.type === 'worker' && note.is_call && !note.voicemail">
              <div class="row">
                <label :class="[note.discussed_tax ? 'col-7 cardLabel' : 'col-8 cardLabel']" for="discussed_tax">Discussed Tax?</label>
                <div :class="[note.discussed_tax ? 'col-5 cardLabel' : 'col-4 cardLabel']">
                  <bootstrap-toggle v-model="note.discussed_tax" name="discussed_tax" id="discussed_tax" :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>
            <div class="col-6" v-if="$store.state.notes.type === 'worker' && note.discussed_tax && !note.voicemail">
              <div class="row">
                <label class="col-7 cardLabel" for="sold_tax">Sold Tax</label>
                <div class="col-5">
                  <bootstrap-toggle v-model="note.sold_tax" name="sold_tax" id="sold_tax" :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>

            <div class="col-12 form-group">
              <ValidationProvider rules="required" v-slot="{errors, classes}" name="Note Content" tag="div">
                <label class="form-label" for="note_content">Note Content</label>
                <textarea v-model="note.note" rows="15" name="note_content" class="form-input resize_vertical requiredField" :class="classes" id="note_content"></textarea>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="col-6 offset-6">
                <button type="submit" class="btn orcaBtn w-100 sm_btn">SAVE and CLOSE</button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import BootstrapToggle from 'vue-bootstrap-toggle';

export default {
  name: "add_note",
  components: {
    Multiselect,
    BootstrapToggle
  },
  data() {
    return {
      company_note_on: {company_id: this.$store.state.notes.id, contact_id: '', name: 'Company Record', job_title: this.$store.state.notes.name},

      ms_opts: {
        company_note_on: [],
        note_type: [],
        call_type: ['Incoming', 'Outgoing']
      },
      note: {
        type: null,
        is_call: false,
        voicemail: false,
        call_type: null,
        decision_maker: false,
        discussed_tax: false,
        sold_tax: false,
        note: ''
      },
    }
  },
  beforeMount() {
    if (this.$store.state.notes.type === 'company') {
      this.ms_opts.note_type = this.$store.state.crm_options.note_types.company;
      // this.ms_opts.note_type = [];
      let company_note_on = [];
      let passed_contacts = this.$store.state.notes.contacts;

      for (let i = 0; i < passed_contacts.length; i++) {
        let job_title = '';
        if ((passed_contacts[i].rel_profile !== null && Object.keys(passed_contacts[i].rel_profile).length > 1) && passed_contacts[i].rel_profile.job_title_id !== null &&
            passed_contacts[i].rel_profile.job_title !== null) {
          job_title = passed_contacts[i].rel_profile.job_title.job_title;
        }
        company_note_on.push({
          company_id: passed_contacts[i].company_id, contact_id: passed_contacts[i].id, name: passed_contacts[i].person.first_name + ' ' +
              passed_contacts[i].person.surname, job_title: job_title
        })
      }
      company_note_on.push({company_id: this.$store.state.notes.id, contact_id: '', name: 'Company Record', job_title: this.$store.state.notes.name})
      this.ms_opts.company_note_on = company_note_on;
    }
    if (this.$store.state.notes.type === 'contact') {
      this.ms_opts.note_type = this.$store.state.crm_options.note_types.company;
    }
    else if (this.$store.state.notes.type === 'worker') {
      this.ms_opts.note_type = this.$store.state.crm_options.note_types.worker;
    }
    else if (this.$store.state.notes.type === 'order_job') {
      this.ms_opts.note_type = this.$store.state.crm_options.note_types.order_job;
    }
  },
  methods: {
    note_on_label({job_title, name}) {
      return `${job_title} - ${name}`;
    },
    note_type_label({division, note_type}) {
      return `[${division}] - ${note_type}`
    },
    hideModal() {
      this.$refs.add_note_modal.hide();
      this.$store.commit('HIDE_NOTE_MODALS');
    },
    create_note() {
      this.$refs.addNoteForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.addNoteForm);
        }
        else {
          let submit_note = {
            belongs_to_type: '',
            belongs_to_id: this.$store.state.notes.id,
            note_type_id: this.note.type.id,
            is_call: this.note.is_call,
            voicemail: this.note.voicemail,
            call_type: this.note.call_type,
            decision_maker: this.note.decision_maker,
            discussed_tax: this.note.discussed_tax,
            sold_tax: this.note.sold_tax,
            note: this.note.note,
            log_by_type: 'App\\Models\\Users\\User',
            log_by_id: this.$store.state.auth.me.id
          }
          let note_added_for = '';
          // Save note -- depending on type
          if (this.$store.state.notes.type === 'company') {
            // if note is on company or on contacts
            if (this.company_note_on.name === 'Company Record') {
              submit_note.belongs_to_type = 'App\\Models\\Companies\\Company';
            }
            else {
              submit_note.contact_id = this.company_note_on.contact_id;
              submit_note.belongs_to_type = 'App\\Models\\Companies\\Contacts\\Contact';
              submit_note.belongs_to_id = this.company_note_on.contact_id;
            }
            submit_note.company_id = this.$store.state.notes.id;
            note_added_for = this.company_note_on.name;
          }
          else if (this.$store.state.notes.type === 'contact') {
            submit_note.contact_id = this.$store.state.notes.id;
            submit_note.belongs_to_type = 'App\\Models\\Companies\\Contacts\\Contact';
            note_added_for = this.$store.state.notes.name;
          }
          else if (this.$store.state.notes.type === 'worker') {
            submit_note.worker_id = this.$store.state.notes.id;
            submit_note.belongs_to_type = 'App\\Models\\Workers\\Worker';
            note_added_for = this.$store.state.notes.name;
          }
          else if (this.$store.state.notes.type === 'order_job') {
            submit_note.order_job_id = this.$store.state.notes.id;
            submit_note.belongs_to_type = 'App\\Models\\Orders\\Jobs\\OrderJob';
            note_added_for = this.$store.state.notes.name;
          }
          axios.post(this.crmApiPath + 'note', submit_note).then(() => {
            this.$snotify.success('Note added for ' + note_added_for, 'Note Added');
            this.$bus.$emit('note::reload', {action: true});
            this.$bus.$emit('logs::reload', {action: true});
            if (this.$store.state.notes.type === 'company') {
              this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'});
            }
            if (this.$store.state.notes.type === 'worker') {
              this.$bus.$emit('table::reload', {
                table: 'work_status', 
                type: 'update', 
                worker_id: this.$store.state.notes.id
              });
            }
            this.hideModal();
          });
        }
      });
    }
  },
  watch: {
    'note.is_call'(val) {
      if (!val) {
        this.note.voicemail = false;
        this.note.discussed_tax = false;
        this.note.decision_maker = false;
        this.note.call_type = null;
      }
    },
    'note.voicemail'(val) {
      if (!val) {
        this.note.discussed_tax = false;
        this.note.decision_maker = false;
        this.note.call_type = null;
      }
      if (val) {
        this.note.call_type = 'Outgoing';
      }
    },
    'note.discussed_tax'(val) {
      if (!val) {
        this.note.sold_tax = false;
      }
    },
  }
}
</script>
<style lang="scss">
#add_note_modal {
  .multiselect__option {
    height: auto !important;
  }

  .option__desc {
    .option__title {
      font-weight: bold;
      display:     block;
    }

    .option__small {
      font-size: 0.7rem;
      display:   block;
    }
  }
}
</style>
